<template>
    <div class="setting-page">
        <div class="container">
            <el-tabs v-model="activeName">
                <el-tab-pane label="基本信息" name="first">
                    <el-form label-position="left" label-width="100px" status-icon class="setting-form setting-form-sm">
                        <el-form-item label="名称">
                            <el-input type="text" placeholder="请输入名称" v-model="pz.name"></el-input>
                        </el-form-item>
                        <el-form-item label="店铺地址">
                            <el-cascader size="large" :options="pcaTextArr" v-model="pz.address">
                            </el-cascader>
                            <el-input type="text" placeholder="请输入详细地址" v-model="pz.detailed"></el-input>
                        </el-form-item>
                        <el-form-item label="轮播图">
                            <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file"
                                list-type="picture-card" ref="upload" :auto-upload="true"
                                :on-success="handleAvatarSuccess" :file-list="fileList">
                                <i slot="default" class="el-icon-plus"></i>
                                <div slot="file" slot-scope="{file}">
                                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                    <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview"
                                            @click="handlePictureCardPreview(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="公告">
                            <el-input type="textarea" placeholder="请输入公告信息" v-model="pz.announcement"></el-input>
                        </el-form-item>
                        <el-form-item label="搜索词">
                            <el-tag :key="tag" v-for="tag in pz.keywords" closable :disable-transitions="false"
                                @close="handleClose(tag)">
                                {{ tag }}
                            </el-tag>
                            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                                size="small" @blur="handleInputConfirm">
                            </el-input>
                            <el-button v-else class="button-new-tag" size="small" @click="showInput">添加关键词</el-button>
                        </el-form-item>
                        <el-form-item label="自提描述">
                            <el-input type="text" placeholder="请输入自提描述" v-model="pz.ztDepict"></el-input>
                        </el-form-item>
                        <el-form-item label="运费描述">
                            <el-input type="text" placeholder="请输入运费描述" v-model="pz.yyDepict"></el-input>
                        </el-form-item>
                        <el-form-item label="服务描述">
                            <el-input type="text" placeholder="请输入服务描述" v-model="pz.serviceDepict"></el-input>
                        </el-form-item>
                        <el-form-item label="底部logo">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(1, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload1">
                                <img v-if="pz.logoUrl || pz.logo" :src="pz.logoUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="品牌故事">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(2, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload2">
                                <img v-if="pz.ppImageUrl || pz.ppImage" :src="pz.ppImageUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="公众号链接">
                            <el-input type="text" placeholder="请输入链接" v-model="pz.articleLink"></el-input>
                        </el-form-item>
                        <el-form-item label="预留图">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(3, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload3">
                                <img v-if="pz.llImageUrl || pz.llImage" :src="pz.llImageUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="买家秀顶部图">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(4, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload4">
                                <img v-if="pz.showImageUrl || pz.showImage" :src="pz.showImageUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="温馨提示图">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(5, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload5">
                                <img v-if="pz.hintImageUrl || pz.hintImage" :src="pz.hintImageUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="分享封面">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(7, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload7">
                                <img v-if="pz.shareCoverUrl || pz.shareCover" :src="pz.shareCoverUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <div style="color:#999;font-size:12px;margin-top:6px">用于小程序各页面分享时的封面图片（建议尺寸 5:4）</div>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="客服信息" name="second">
                    <el-form label-position="left" label-width="80px" status-icon class="setting-form setting-form-md">
                        <el-form-item label="微信号">
                            <el-input placeholder="请输入微信号" prefix-icon="el-icon-edit" v-model="pz.wechatId"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式">
                            <el-input placeholder="请输入联系方式" prefix-icon="el-icon-edit" v-model="pz.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="服务时间">
                            <el-input placeholder="示例:08:00-22:30" prefix-icon="el-icon-edit"
                                v-model="pz.servicingTime"></el-input>
                        </el-form-item>
                        <el-form-item label="客服二维码">
                            <el-upload class="avatar-uploader" :action="this.$base.file" name="file"
                                :on-success="(res, file) => { handleImageSuccess(6, res, file) }"
                                :show-file-list="false" :limit="1" ref="upload6">
                                <img v-if="pz.kfQrImageUrl || pz.kfQrImage" :src="pz.kfQrImageUrl || ''" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <div style="color:#999;font-size:12px;margin-top:6px">用于小程序客服页面展示的微信二维码</div>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="消息通知" name="notify">
                    <el-form label-position="left" label-width="120px" status-icon class="setting-form setting-form-md-lg">
                        <el-alert type="info" show-icon :closable="false"
                            title="配置商家接收订单通知的邮箱，下单/支付/退款申请/退款完成将自动发送邮件。支持多个邮箱，以逗号分隔。"
                            style="margin-bottom:20px;">
                        </el-alert>
                        <el-form-item label="通知邮箱">
                            <el-input placeholder="例: shop@domain.com 或 a@x.com,b@x.com" prefix-icon="el-icon-message"
                                v-model="pz.notifyEmail"></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="订购/保养须知" name="notice">
                    <el-form label-position="left" label-width="120px" status-icon class="setting-form setting-form-lg">
                        <el-alert type="info" show-icon :closable="false"
                            title="配置内容将展示在小程序商品详情页「订购须知」与「保养须知」区域。可使用回车分段，支持多行文本。"
                            style="margin-bottom:20px;">
                        </el-alert>
                        <el-form-item label="订购须知">
                            <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 20 }"
                                placeholder="请输入订购须知，例如：订购100%实拍实发、相关发货时间说明等"
                                v-model="pz.orderNotice"></el-input>
                        </el-form-item>
                        <el-form-item label="保养须知">
                            <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 20 }"
                                placeholder="请输入保养须知，例如：鲜花保养方法、注意事项等"
                                v-model="pz.careNotice"></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="配送时段" name="timeSlots">
                    <div class="handle-box" style="margin-bottom: 20px;">
                        <el-button type="primary" @click="showAddSlot = true" icon="el-icon-circle-plus">添加时段</el-button>
                    </div>
                    <el-alert type="info" show-icon :closable="false"
                        title="配置小程序下单页可选的配送时段，下单用户可从中选择配送时间段。例如：09:00-12:00、14:00-18:00"
                        style="margin-bottom:20px;">
                    </el-alert>
                    <el-table :data="timeSlotsList" border class="table table-then-card" style="max-width:500px">
                        <el-table-column prop="slot" label="时间段" align="center"></el-table-column>
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                                    @click="removeTimeSlot(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 手机端卡片列表 - 配送时段 -->
                    <div class="mobile-card-list">
                        <div v-for="(row, idx) in timeSlotsList" :key="idx" class="mc-card">
                            <div class="mc-header">
                                <span class="mc-title">{{ row.slot }}</span>
                                <el-button size="small" type="danger" icon="el-icon-delete" @click="removeTimeSlot(idx)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="timeSlotsList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无时段</div>
                    </div>
                    <el-button type="success" @click="saveTimeSlots" icon="el-icon-edit" size="small" style="margin-top:20px">保存时段设置</el-button>
                </el-tab-pane>
                <el-tab-pane label="配送区域" name="ft">
                    <div class="handle-box" style="margin-bottom: 20px;">
                        <el-button type="primary" @click="tian = true" icon="el-icon-circle-plus">添加区域</el-button>
                    </div>
                    <el-table :data="freightsList" border class="table table-then-card" ref="filterTable">
                        <el-table-column prop="name" label="区域名称" align="center"></el-table-column>
                        <el-table-column prop="startKm" label="起算距离(km)" align="center" width="130"></el-table-column>
                        <el-table-column prop="pricePerKm" label="每公里单价(元/km)" align="center" width="150"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit-outline" style="color:green"
                                    @click="handleFtUp(scope.$index, scope.row)">
                                    修改
                                </el-button>
                                <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                                    @click="handleFtDe(scope.$index, scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 手机端卡片列表 - 配送区域 -->
                    <div class="mobile-card-list">
                        <div v-for="(row, idx) in freightsList" :key="idx" class="mc-card">
                            <div class="mc-header">
                                <span class="mc-title">{{ row.name }}</span>
                            </div>
                            <div class="mc-grid-2">
                                <div class="mc-row">
                                    <span class="mc-label">起算距离</span>
                                    <span class="mc-value">{{ row.startKm }}km</span>
                                </div>
                                <div class="mc-row">
                                    <span class="mc-label">每公里单价</span>
                                    <span class="mc-value">¥{{ row.pricePerKm }}/km</span>
                                </div>
                            </div>
                            <div class="mc-actions">
                                <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="handleFtUp(idx, row)">修改</el-button>
                                <el-button size="small" type="danger" icon="el-icon-delete" @click="handleFtDe(idx, row)">删除</el-button>
                            </div>
                        </div>
                        <div v-if="freightsList.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无区域</div>
                    </div>
                    <div class="pagination">
                        <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="size"
                            layout="total, prev, pager, next" :total="total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <el-button v-if="activeName != 'ft' && activeName != 'timeSlots'" type="success" @click="onSystemSave" icon="el-icon-edit" size="small"
                style="margin-top: 50px;">保存修改</el-button>

            <el-dialog title="添加配送时段" :visible.sync="showAddSlot" :width="dialogWidthSmall">
                <el-form label-width="80px">
                    <el-form-item label="时间段">
                        <el-input v-model="newSlot" placeholder="例：09:00-12:00" clearable></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button type="primary" @click="confirmAddSlot">确 定</el-button>
                    <el-button @click="showAddSlot = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog title="添加区域" :visible.sync="tian" :width="dialogWidthSmall">
                <el-form label-position="left" :rules="rules" ref="ftObj" label-width="150px" :model="ftObj"
                    status-icon>
                    <el-form-item label="分类名称" prop="name">
                        <el-cascader size="large" :options="pcaTextArr" v-model="ftObj.name">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="起算距离(km)">
                        <el-input-number v-model="ftObj.startKm" :precision="2" :min="0" placeholder="超过此距离才收费"></el-input-number>
                        <span style="color:#999;font-size:12px;margin-left:8px">设置0则从0公里起算</span>
                    </el-form-item>
                    <el-form-item label="每公里单价(元/km)">
                        <el-input-number v-model="ftObj.pricePerKm" :precision="2" :min="0"></el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="subAdd('ftObj')"> 定</el-button>
                    <el-button @click="tian = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog title="修改区域" :visible.sync="upg" :width="dialogWidthSmall">
                <el-form label-position="left" :rules="ruless" ref="ftUObj" label-width="150px" :model="ftUObj"
                    status-icon>
                    <el-form-item label="区 域" prop="name">
                        <el-cascader size="large" :options="pcaTextArr" v-model="ftUObj.name">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="起算距离(km)">
                        <el-input-number v-model="ftUObj.startKm" :precision="2" :min="0"></el-input-number>
                        <span style="color:#999;font-size:12px;margin-left:8px">超过此距离才收费</span>
                    </el-form-item>
                    <el-form-item label="每公里单价(元/km)">
                        <el-input-number v-model="ftUObj.pricePerKm" :precision="2" :min="0"></el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="subUp('ftUObj')"> 定</el-button>
                    <el-button @click="upg = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { querySystems, updateSystems, queryFreights, addFreights, updateFreights, deleteFreights, getDeliveryTimeSlots, saveDeliveryTimeSlots } from '@/api/index.js';
import { pcaTextArr } from 'element-china-area-data'
export default {
    name: 'Setting',
    data() {
        return {
            pcaTextArr,
            url: '',
            activeName: 'first',
            tian: false,
            upg: false,
            freightsList: [],
            ftObj: {
                name: ''
            },
            ftUObj: {},
            page: 1,
            size: 5,
            total: 0,
            pz: {
                name:'',
                address:[],
                detailed:'',
                keywords: [],
                swipers: [],
                announcement: '',
                logo: '',
                ppImage: '',
                llImage: '',
                phone: '',
                wechatId: '',
                servicingTime: '',
                ztDepict:'',
                yyDepict: '',
                showImage: '',
                hintImage: '',
                articleLink: '',
                serviceDepict: '',
                notifyEmail: '',
                orderNotice: '',
                careNotice: '',
                kfQrImage: '',
                shareCover: ''
            },
            inputVisible: false,
            inputValue: '',
            fileList: [],
            dialogVisible: false,
            dialogImageUrl: '',
            upPz: {},
            rules: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" }
                ]
            },
            ruless: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" }
                ]
            },
            // 配送时段
            timeSlotsList: [],
            showAddSlot: false,
            newSlot: ''
        }
    },
    computed: {
        dialogWidthSmall() {
            return window.innerWidth < 768 ? '95%' : '500px';
        }
    },
    methods: {
        //配送时段相关
        confirmAddSlot() {
            const s = (this.newSlot || '').trim();
            if (!s) { this.$message.warning('请输入时间段'); return; }
            if (this.timeSlotsList.find(i => i.slot === s)) { this.$message.warning('该时间段已存在'); return; }
            this.timeSlotsList.push({ slot: s });
            this.newSlot = '';
            this.showAddSlot = false;
        },
        removeTimeSlot(index) {
            this.timeSlotsList.splice(index, 1);
        },
        async saveTimeSlots() {
            const slots = this.timeSlotsList.map(i => i.slot);
            try {
                const res = await saveDeliveryTimeSlots({
                    sid: this.pz.sid,
                    deliveryTimeSlots: JSON.stringify(slots)
                });
                if (res.code != 0) { this.$message.warning(res.msg); return; }
                this.$message.success('配送时段保存成功');
            } catch(e) { this.$message.error('保存失败'); }
        },
        async getTimeSlots() {
            try {
                const res = await getDeliveryTimeSlots();
                const list = (res.data || []);
                this.timeSlotsList = list.map(s => ({ slot: s }));
            } catch(e) {}
        },
        //修改区域
        handleFtUp(index, row) {
            let obj = JSON.stringify(row);
            obj = JSON.parse(obj);
            obj.name = obj.name.split(' ');
            this.ftUObj = obj;
            this.upg = true;
        },
        //添加
        subAdd(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定添加该区域?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.ftObj;
                        obj.name = obj.name.join(' ');
                        addFreights(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.tian = false;
                            this.$msg({
                                showClose: true,
                                message: msg,
                                type: "success",
                            });
                            this.ftObj = {
                                name: '',
                                print: 0
                            }
                            this.getFt();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //修改
        subUp(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定修改该区域?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.ftUObj;
                        obj.name = obj.name.join(' ');
                        updateFreights(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.upg = false;
                            this.$msg({
                                showClose: true,
                                message: msg,
                                type: "success",
                            });
                            this.getFt();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //删除指定区域
        handleFtDe(index, row) {
            this.$confirm("是否确定删除该区域?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteFreights(row.fid).then((res) => {
                    let { code, msg } = res;
                    if (code != 0) {
                        this.$message.error('删除失败');
                        return false;
                    }
                    this.$message.success('删除成功');
                    this.freightsList = this.freightsList.filter((todo) => {
                        return todo.fid != row.fid;
                    })
                })
            })
        },
        //删除关键词
        handleClose(tag) {
            this.pz.keywords.splice(this.pz.keywords.indexOf(tag), 1);
        },
        //上传图片：后端返回 { key: objectKey, url: 预签名URL }
        handleImageSuccess(n, res, file) {
            if (res.code != 0) {
                this.$message.warning('上传失败');
            } else {
                const data = res.data || {};
                const key = data.key;
                const previewUrl = data.url;
                switch (n) {
                    case 1:
                        this.$set(this.pz, 'logo', key);
                        this.$set(this.pz, 'logoUrl', previewUrl);
                        break;
                    case 2:
                        this.$set(this.pz, 'ppImage', key);
                        this.$set(this.pz, 'ppImageUrl', previewUrl);
                        break;
                    case 3:
                        this.$set(this.pz, 'llImage', key);
                        this.$set(this.pz, 'llImageUrl', previewUrl);
                        break;
                    case 4:
                        this.$set(this.pz, 'showImage', key);
                        this.$set(this.pz, 'showImageUrl', previewUrl);
                        break;
                    case 5:
                        this.$set(this.pz, 'hintImage', key);
                        this.$set(this.pz, 'hintImageUrl', previewUrl);
                        break;
                    case 6:
                        this.$set(this.pz, 'kfQrImage', key);
                        this.$set(this.pz, 'kfQrImageUrl', previewUrl);
                        break;
                    case 7:
                        this.$set(this.pz, 'shareCover', key);
                        this.$set(this.pz, 'shareCoverUrl', previewUrl);
                        break;
                }
            }
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.pz.keywords.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        // 判断上传的是否为图片
        handleBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            return suffix || suffix2 || suffix3
        },
        handleRemove(file) {
            const uploadFiles = this.$refs.upload.uploadFiles;
            for (let i in uploadFiles) {
                if (file.url === uploadFiles[i].url) {
                    uploadFiles.splice(i, 1);
                    this.pz.swipers.splice(i, 1);
                    this.fileList.splice(i, 1);
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //上传轮播图：后端返回 { key: objectKey, url: 预签名URL }
        handleAvatarSuccess(res, file) {
            if (res.code != 0) {
                this.$message.error('上传失败')
            } else {
                const data = res.data || {};
                const key = data.key;
                const previewUrl = data.url;
                file.url = previewUrl;
                this.pz.swipers.push(key);
                this.fileList.push({ url: previewUrl });
                this.$refs.upload.clearFiles()
            }
        },
        //切换页数
        handleCurrentChange(val) {
            this.page = val;
            this.getFt();
        },
        //保存
        async onSystemSave() {
            let obj = JSON.stringify(this.pz);
            obj = JSON.parse(obj);
            obj.address=obj.address.join(' ');
            obj.keywords = JSON.stringify(obj.keywords);
            obj.swipers = JSON.stringify(obj.swipers);
            let res = await updateSystems(obj);
            if (res.code != 0) {
                this.$message.warning(res.msg);
                return false;
            }
            this.$message.success(res.msg);
        },
        async getFt() {
            try {
                let pageNum = this.page;
                let pageSize = this.size;
                let res = await queryFreights({ pageNum, pageSize });
                this.freightsList = res.list;
                this.total = res.total;
            } catch (error) {
                this.$message.error('服务器错误');
            }
        },
        async getData() {
            try {
                let res = await querySystems();
                let data = res.data;
                data.keywords = data.keywords ? (JSON.parse(data.keywords) || []) : [];
                // 轮播图：swipers 存 objectKey 数组，swipersUrl 存对应签名 URL 数组
                const signedSwipers = Array.isArray(data.swipersUrl) ? data.swipersUrl : [];
                data.swipers = data.swipers ? (JSON.parse(data.swipers) || []) : [];
                data.address = data.address ? data.address.split(' ') : [];
                let list = [];
                for (let i = 0; i < data.swipers.length; i++) {
                    list.push({ url: signedSwipers[i] || '' });
                }
                this.pz = data;
                this.fileList = list;
                setTimeout(() => {
                    this.loading = false;
                }, 600)
            } catch (error) {
                console.log(error);

                this.$message.warning('服务器错误');
            }
        }
    },
    created() {
        this.url = this.$base.url;
        this.getData();
        this.getFt();
        this.getTimeSlots();
    }
}
</script>

<style scoped>
.setting-page {
    height: calc(100vh - 110px);
    overflow-y: auto;
}

.setting-form-sm {
    width: 40%;
}
.setting-form-md {
    width: 50%;
}
.setting-form-md-lg {
    width: 60%;
}
.setting-form-lg {
    width: 70%;
}

.red {
    color: #ff0000;
}

.avatar-uploader {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    border-radius: 6px;
    height: 150px;
    cursor: pointer;
    border: 1px #cdcdcd dashed;
}

.avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
}

.avatar {
    width: 100%;
    height: 100%;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .setting-page {
    height: calc(100vh - 56px);
  }
  .setting-form-sm,
  .setting-form-md,
  .setting-form-md-lg,
  .setting-form-lg {
    width: 100% !important;
  }
  .el-table {
    font-size: 13px;
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .setting-page {
    height: calc(100vh - 56px);
  }
  .setting-form-sm {
    width: 60%;
  }
  .setting-form-md {
    width: 70%;
  }
  .setting-form-md-lg {
    width: 80%;
  }
  .setting-form-lg {
    width: 90%;
  }
}
</style>